import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useCompare } from "../../providers/CompareProvider";
import "./CompareBar.css";

// Floating tray shown whenever the learner has 1+ tutors/centres queued up
// for comparison — visible from any page (search, a profile, etc.) so they
// can keep browsing and adding before jumping to /compare.
const HIDE_ON = ["/login", "/create-account", "/compare"];

const CompareBar = () => {
  const { selected, remove, clear, maxCompare } = useCompare();
  const navigate = useNavigate();
  const location = useLocation();

  if (selected.length === 0) return null;
  if (HIDE_ON.includes(location.pathname)) return null;

  return (
    <div className="compare-bar">
      <div className="compare-bar-items">
        {selected.map((item) => (
          <div key={item.id} className="compare-bar-item">
            <img
              src={item.avatar || "/images/avatar3.png"}
              alt={item.displayName}
              onError={(e) => {
                e.target.src = "/images/avatar3.png";
              }}
            />
            <span>{item.displayName}</span>
            <button
              type="button"
              aria-label={`Remove ${item.displayName} from comparison`}
              onClick={() => remove(item.id)}
            >
              &times;
            </button>
          </div>
        ))}
      </div>

      <div className="compare-bar-actions">
        <span className="compare-bar-count">
          {selected.length}/{maxCompare} selected
        </span>
        <button type="button" className="compare-bar-clear" onClick={clear}>
          Clear
        </button>
        <button
          type="button"
          className="compare-bar-cta"
          disabled={selected.length < 2}
          onClick={() => navigate("/compare")}
        >
          Compare {selected.length > 1 ? `(${selected.length})` : ""}
        </button>
      </div>
    </div>
  );
};

export default CompareBar;
